import script from "./MachineryDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./MachineryDetail.vue?vue&type=script&setup=true&lang=js"

import "./MachineryDetail.vue?vue&type=style&index=0&id=5707a5c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5707a5c2"]])

export default __exports__